/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SuspectedTradeUserLoader_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SuspectedTradeUser_viewer" | "MobileSuspectedTradeUser_viewer">;
    readonly " $refType": "SuspectedTradeUserLoader_viewer";
};
export type SuspectedTradeUserLoader_viewer$data = SuspectedTradeUserLoader_viewer;
export type SuspectedTradeUserLoader_viewer$key = {
    readonly " $data"?: SuspectedTradeUserLoader_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SuspectedTradeUserLoader_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SuspectedTradeUserLoader_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SuspectedTradeUser_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "MobileSuspectedTradeUser_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '994efb22d2267dbd405643c5fea9f05b';
export default node;
